/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAttribute } from '../../models/api-response-attribute';
import { Attribute } from '../../models/attribute';

export interface CreateAttribute$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Attribute
}

export function createAttribute(http: HttpClient, rootUrl: string, params: CreateAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAttribute>> {
  const rb = new RequestBuilder(rootUrl, createAttribute.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAttribute>;
    })
  );
}

createAttribute.PATH = '/v1/api/ui/referential/attribute';
